import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toastSlice } from 'slices';
import { useTranslation } from 'react-i18next';
import { useDealerRole, useManagerRole } from 'hooks/role';
import { useGetCustomerListQuery } from 'thunks/RTKQuery/dealerCustomer';
import { Spinner2 } from 'components';
import { ICustomerItem, ICustomerObject } from './Models';
import { DealerCustomersDetailContainer } from './DealerCustomersDetailView';
import { DealerCustomersListContainer } from './DealerCustomersListView';

export const DealersCustomerView: React.FC = () => {
  const dispatch = useAppDispatch();
  const [selectedCustomer, setSelectedCustomer] = useState<ICustomerItem>();
  const [customerListData, setCustomerListData] = React.useState<
    ICustomerItem[]
  >([]);
  const { data: authData } = useAppSelector((state) => state.auth);
  const rootDealer = authData?.dealer;
  const [errorString, setErrorString] = useState('');
  const [showList, setShowList] = useState<boolean>(true);
  const { t } = useTranslation();

  const isDealer = useDealerRole();
  const isManager = useManagerRole();
  const createCustomer = () => {
    setSelectedCustomer(undefined);
  };

  useEffect(() => {
    if (errorString !== '') {
      dispatch(
        toastSlice.actions.show({
          title: t('contract.error'),
          message: errorString,
        })
      );
    }
    setErrorString('');
  }, [errorString]);

  const {
    data: customerData = [],
    error: customerListError,
    isLoading: customerListLoading,
  } = useGetCustomerListQuery(
    !isManager ? rootDealer?.dealerId || '0' : '',
    isDealer && rootDealer?.dealerId === undefined ? { skip: true } : {}
  );

  useEffect(() => {
    if (!customerData || !customerData.length) {
      setShowList(false);
      return;
    }
    setShowList(customerData.length > 0);
    setCustomerListData(customerData);
    const list = customerData as ICustomerObject[];
    if (list && list.length > 0 && selectedCustomer === undefined) {
      const selectedObj = list[0];
      setSelectedCustomer(selectedObj);
    }
  }, [customerData]);

  useEffect(() => {
    if (customerListError && 'message' in customerListError) {
      setErrorString(`${customerListError.message}`);
    }
  }, [customerListError]);

  return (
    <>
      <Spinner2 show={customerListLoading} />
      <h1 className="ml-2 mb-4 mt-3">{t('customerManagement.heading')}</h1>
      <hr />
      <Row>
        <Col md={showList ? 4 : 2}>
          <Row>
            {showList && (
              <Col md={12}>
                <DealerCustomersListContainer
                  setSelectedCustomer={setSelectedCustomer}
                  customerData={customerListData}
                  selectedCustomer={selectedCustomer}
                />
              </Col>
            )}
          </Row>
        </Col>
        <Col md={8}>
          <Row>
            <Col md={12} className="d-flex justify-content-end">
              <Button
                onClick={createCustomer}
                className={
                  !showList
                    ? 'btn-outline-primary button-customer-hide-list'
                    : 'btn-outline-primary button-customer'
                }
              >
                {t('customerManagement.newUser')}
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <DealerCustomersDetailContainer
                setErrorString={setErrorString}
                selectedCustomer={selectedCustomer}
                setSelectedCustomer={setSelectedCustomer}
                rootDealer={rootDealer}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
